import { render, staticRenderFns } from "./Google.vue?vue&type=template&id=0092be8c&scoped=true&"
import script from "./Google.vue?vue&type=script&lang=js&"
export * from "./Google.vue?vue&type=script&lang=js&"
import style0 from "./Google.vue?vue&type=style&index=0&id=0092be8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0092be8c",
  null
  
)

export default component.exports